export default {
  methods : {
    initializePageParameters(payload){
      if(typeof payload === 'undefined') payload = {};

      payload = this._.merge({
        'allowFullAccess' : false,
        'asLoginedView'   : false
      },payload);

      return payload;
    },

    async initializePage(payload){
      payload = this.initializePageParameters(payload);

      await this.$store.dispatch({
        type  : 'layouts/updateIsVisiblePageContent',
        value : false
      });

      await this.$store.dispatch({
        type  : 'layouts/updateLoginedView',
        value : false,
      });

      // await this.$store.dispatch({
      //   type  : 'globalLoading/updateGlobalLoading',
      //   value : true,
      // });

      // Loginしていなければ、loadingを解除してページを表示します。
      // afterAuthenicationでonしないで、checkAuthenticationFrontPageのあとに書くと、
      // homeへリダイレクトする場合、一瞬ページが見えてしまうので、onで聞く必要あり
      this.$on('afterAuthenication', () => {
        this.afterAuthenication();
      });

      this.$on('afterLoginedAuthenication', () => {
        this.afterAuthenication();
      });

      this.$on('afterLoginedAuthenicationFail', () => {
        this.afterAuthenication();
      });

      if(payload.allowFullAccess === false){
        if(payload.asLoginedView === true){
          await this.checkAuthenticationLoginedPage();
        }else{
          await this.checkAuthenticationFrontPage();
        }
      }else{
        this.$emit('afterAuthenication');
      }
    },

    afterAuthenication(){
      this.$nextTick(async () => {
        await this.$store.dispatch({
          type  : 'layouts/updateMountedLayoutStyleName',
          value : 'front'
        });

        this.$store.dispatch({
          type  : 'layouts/updateIsNoBodyPullToRefreshAndroid',
          value : false
        });

        await this.$store.dispatch({
          type  : 'globalLoading/updateGlobalLoading',
          value : false,
        });

        await this.$store.dispatch({
          type  : 'layouts/updateIsVisiblePageContent',
          value : true
        });

        this.$nextTick(() => {
          this.$emit('mountedPage');
        });
      });
    }
  },
}